import { Layout } from 'antd';
import { NavigateFunction } from 'react-router-dom';
import Header from '../../../components/Molecules/Header/Header';
import CardView from '../../../components/Organisms/CardView/CardView';
import { ReactComponent as Leading } from '../../../res/svg/card-tag.svg';
import { ReactComponent as Fund } from '../../../res/svg/fund.svg';
import { ReactComponent as Excel } from '../../../res/svg/excel-file-big.svg';
import { ReactComponent as Capas } from '../../../res/svg/capas-white.svg';
import { adminItemsMenu } from '../../../utils/utils';

import './DashboardIndex.less';
/**
 * @page DashboardIndex.tsx
 * @description Main page for the Dashboard.
 * @return { page }
 */
function DashboardIndex() {
  //@ts-ignore
  const user = JSON.parse(localStorage.getItem('currentUser'));
  const accessMenu = [
    {
      text: 'Administración',
      color: 'blue-3',
      icon: <Fund />,
      key: 'accesoAdministracion',
      url: '/admin',
    },
    {
      text: 'Gestor de Tareas',
      color: 'red-4',
      icon: <Leading fontSize={24} />,
      key: 'accesoGestion',
      url: '/tareas',
    },
    {
      text: 'Gestor de Capas',
      color: 'gold-4',
      icon: <Capas/>,
      key: 'accesoCatastro',
      url: '/gestor-de-capas',
    },
    {
      text: 'Gestor de Registros',
      color: 'terciario-3',
      icon: <Excel />,
      key: 'accesoRegistros',
      url: '/gestor-de-registros',
    },
  ];
  const accessOnClick = (item: string, navigate: NavigateFunction) => {
    adminItemsMenu(item, navigate);
    switch (item) {
      case 'Administración': {
        return navigate('/admin');
      }
      case 'Gestor de Tareas': {
        return navigate('/tareas');
      }
      case 'Gestor de Capas': {
        return navigate('/gestor-de-capas');
      }
      case 'Gestor de Registros' : {
        return navigate('/gestor-de-registros');
      }
      default: {
        return '';
      }
    }
  };
  return (
    <Layout className="org-admin__layout">
      <Header user={user} />
      <div className="org-admin__card__section">
        {accessMenu.map(
          (content, ix) =>
            JSON.parse(localStorage.getItem('accessArray')!).includes(
              content.key,
            ) && (
              <CardView
                key={ix}
                text={content.text}
                color={content.color}
                icon={content.icon}
                cardOnClick={accessOnClick}
              />
            ),
        )}
      </div>
    </Layout>
  );
}

export default DashboardIndex;
